define('Inspiredrooms.ei1.Main.View', [
    'PageType.Base.View',
    'Inspiredrooms.ei1.Main.Model',
    'meeting_rooms.tpl'
], function (
    PageTypeBaseView,
    InspiredroomsModel,
    meeting_rooms_tpl
) {
    'use strict';

    var SITE_DOMAIN = 'https://1homeoffice.com/';

    var MEETING_ROOM_FRAGMENTS = [
        '/room/trenza',
        '/room/carrara',
        '/room/courtyard',
        '/room/boston'
    ];

    var ALCOVE_FRAGMENTS = [
        '/room/foyer',
        '/room/palladio',
        '/room/pietra',
        '/room/serpentine',
        '/room/travertine'
    ];

    var VENUE_FRAGMENTS = [
        '/room/innercourtyard',
        '/room/longcourtyard'
    ];

    // Parent-level page fragments
    var WORKSTATION_FRAGMENT    = '/room/workstation';
    var ALCOVES_PARENT_FRAGMENT = '/room/alcoves';

    function getCurrentPath() {
        var path = '';
        if (window.location.hash) {
            path = window.location.hash.replace('#', '');
        } else {
            path = window.location.pathname;
        }
        if (path.charAt(0) !== '/') {
            path = '/' + path;
        }
        return path.toLowerCase();
    }

    function buildRoomCards(meetingRoomPages, alcovePages, venuePages) {
        meetingRoomPages = meetingRoomPages || [];
        alcovePages      = alcovePages      || [];
        venuePages       = venuePages       || [];

        var groups = [
            { fragments: MEETING_ROOM_FRAGMENTS, rooms: meetingRoomPages },
            { fragments: ALCOVE_FRAGMENTS,        rooms: alcovePages      },
            { fragments: VENUE_FRAGMENTS,         rooms: venuePages       }
        ];
        var cards = [];

        for (var g = 0; g < groups.length; g++) {
            for (var f = 0; f < groups[g].fragments.length; f++) {
                var frag   = groups[g].fragments[f];
                var slug   = getLastSegment(frag);
                var needle = slug.replace(/-/g, '');

                for (var r = 0; r < groups[g].rooms.length; r++) {
                    var nm = (groups[g].rooms[r].name || '').toLowerCase().replace(/\s+/g, '');
                    if (nm.indexOf(needle) !== -1) {
                        cards.push({
                            slug:      slug,
                            url:       frag,
                            thumbnail: buildImageUrl(groups[g].rooms[r].thumbnail)
                        });
                        break;
                    }
                }
            }
        }
        return cards;
    }

    // Build slider cards for the 5 individual alcove children
    function buildAlcoveSliderCards(alcovePages) {
        alcovePages = alcovePages || [];
        var cards   = [];

        for (var f = 0; f < ALCOVE_FRAGMENTS.length; f++) {
            var frag   = ALCOVE_FRAGMENTS[f];
            var slug   = getLastSegment(frag);
            var needle = slug.replace(/-/g, '');

            for (var r = 0; r < alcovePages.length; r++) {
                var nm = (alcovePages[r].name || '').toLowerCase().replace(/\s+/g, '');
                if (nm.indexOf(needle) !== -1) {
                    cards.push({
                        slug:        slug,
                        url:         frag,
                        name:        alcovePages[r].name        || '',
                        description: alcovePages[r].description || '',
                        thumbnail:   buildImageUrl(alcovePages[r].thumbnail)
                    });
                    break;
                }
            }
        }
        return cards;
    }

    function matchesFragment(currentPath, fragments) {
        for (var i = 0; i < fragments.length; i++) {
            if (currentPath.indexOf(fragments[i]) !== -1) {
                return true;
            }
        }
        return false;
    }

    function getLastSegment(urlPath) {
        var parts = (urlPath || '').replace(/\/$/, '').split('/');
        return parts[parts.length - 1].toLowerCase();
    }

    function findRoomBySegment(rooms, currentPath) {
        var segment = getLastSegment(currentPath);
        for (var i = 0; i < rooms.length; i++) {
            var roomName = (rooms[i].name || '').toLowerCase().replace(/\s+/g, '');
            if (roomName.indexOf(segment) !== -1) {
                return rooms[i];
            }
        }
        return null;
    }

    function buildImageUrl(path) {
        if (!path) return '';
        if (path.indexOf('http') === 0) return path;
        return SITE_DOMAIN + path;
    }

    return PageTypeBaseView.PageTypeBaseView.extend({
        template: meeting_rooms_tpl,

        initialize: function initialize() {
            this.model = new InspiredroomsModel();
        },

        beforeShowContent: function beforeShowContent() {
            return this.model.fetch();
        },

        getContext: function getContext() {
            var response = this.model.toJSON();

            var currentPath = getCurrentPath();
            console.log('=== CURRENT PATH ===', currentPath);

            var inspiredSpace = (response && response.data && response.data[0]) ? response.data[0] : {};
            var level2        = inspiredSpace.subCategories || [];

            var eventVenue = null;
            var coworking  = null;

            for (var i = 0; i < level2.length; i++) {
                if (level2[i].name.toLowerCase().indexOf('event') !== -1) {
                    eventVenue = level2[i];
                } else if (level2[i].name.toLowerCase().indexOf('coworking') !== -1) {
                    coworking = level2[i];
                }
            }

            var venuePages = eventVenue ? (eventVenue.subCategories || []) : [];

            var meetingRoom = null;
            var workspace   = null;
            var level3      = coworking ? (coworking.subCategories || []) : [];

            for (var j = 0; j < level3.length; j++) {
                if (level3[j].name.toLowerCase().indexOf('meeting') !== -1) {
                    meetingRoom = level3[j];
                } else if (level3[j].name.toLowerCase().indexOf('workspace') !== -1) {
                    workspace = level3[j];
                }
            }

            var meetingRoomPages = meetingRoom ? (meetingRoom.subCategories || []) : [];

            // Level 4 under Workspace: Workstation node + Alcoves node
            var workstationNode = null;
            var alcovesNode     = null;
            var level4          = workspace ? (workspace.subCategories || []) : [];

            for (var k = 0; k < level4.length; k++) {
                if (level4[k].name.toLowerCase().indexOf('alcove') !== -1) {
                    alcovesNode = level4[k];
                } else if (level4[k].name.toLowerCase().indexOf('workstation') !== -1) {
                    workstationNode = level4[k];
                }
            }

            // Level 5: the 5 individual alcove children
            var alcovePages = alcovesNode ? (alcovesNode.subCategories || []) : [];

            // ── Page type detection ──────────────────────────────────────────────
            var isMeetingRoom   = matchesFragment(currentPath, MEETING_ROOM_FRAGMENTS);
            var isAlcove        = matchesFragment(currentPath, ALCOVE_FRAGMENTS);
            var isVenueSpace    = matchesFragment(currentPath, VENUE_FRAGMENTS);
            var isWorkstation   = currentPath.indexOf(WORKSTATION_FRAGMENT)    !== -1;
            var isAlcovesParent = currentPath.indexOf(ALCOVES_PARENT_FRAGMENT) !== -1;

            console.log('=== IS MEETING ROOM ===',   isMeetingRoom);
            console.log('=== IS ALCOVE ===',          isAlcove);
            console.log('=== IS VENUE SPACE ===',     isVenueSpace);
            console.log('=== IS WORKSTATION ===',     isWorkstation);
            console.log('=== IS ALCOVES PARENT ===',  isAlcovesParent);

            // ── Workstation parent page ──────────────────────────────────────────
            if (isWorkstation && workstationNode) {
                return {
                    isMeetingRoom:    false,
                    isAlcove:         false,
                    isVenueSpace:     false,
                    isWorkstation:    true,
                    isAlcovesParent:  false,
                    roomName:         workstationNode.name               || '',
                    meetingroomDesc:  workstationNode.meetingDescription || '',
                    Description:      workstationNode.description        || '',
                    thumbnail:        buildImageUrl(workstationNode.thumbnail),
                    pageBanner:       buildImageUrl(workstationNode.pageBanner),
                    roomImage:        buildImageUrl(workstationNode.roomImage),
                    roomCapacity:     workstationNode.roomCapacity        || '',
                    roomCards:        buildRoomCards(meetingRoomPages, alcovePages, venuePages),
                    message:          ''
                };
            }

            // ── Alcoves parent page ──────────────────────────────────────────────
            if (isAlcovesParent && alcovesNode) {
                return {
                    isMeetingRoom:     false,
                    isAlcove:          false,
                    isVenueSpace:      false,
                    isWorkstation:     false,
                    isAlcovesParent:   true,
                    roomName:          alcovesNode.name               || '',
                    meetingroomDesc:   alcovesNode.meetingDescription || '',
                    Description:       alcovesNode.description        || '',
                    thumbnail:         buildImageUrl(alcovesNode.thumbnail),
                    pageBanner:        buildImageUrl(alcovesNode.pageBanner),
                    roomImage:         buildImageUrl(alcovesNode.roomImage),
                    roomCapacity:      alcovesNode.roomCapacity        || '',
                    alcoveSliderCards: buildAlcoveSliderCards(alcovePages),
                    decorativeImage:   buildImageUrl(alcovesNode.thumbnail),
                    roomCards:         buildRoomCards(meetingRoomPages, alcovePages, venuePages),
                    message:           ''
                };
            }

            // ── Individual room / alcove / venue pages (existing logic) ──────────
            var currentRoom = null;

            if (isMeetingRoom) {
                currentRoom = findRoomBySegment(meetingRoomPages, currentPath);
            } else if (isAlcove) {
                currentRoom = findRoomBySegment(alcovePages, currentPath);
            } else if (isVenueSpace) {
                currentRoom = findRoomBySegment(venuePages, currentPath);
            }

            console.log('=== CURRENT ROOM ===', JSON.stringify(currentRoom));

            if (!currentRoom) {
                console.error('=== ROOM NOT FOUND for path ===', currentPath);
                return {
                    isMeetingRoom:    isMeetingRoom,
                    isAlcove:         isAlcove,
                    isVenueSpace:     isVenueSpace,
                    isWorkstation:    false,
                    isAlcovesParent:  false,
                    roomName:         '',
                    roomDesc:         '',
                    thumbnail:        '',
                    pageBanner:       '',
                    roomImage:        '',
                    roomCapacity:     '',
                    roomCards:        buildRoomCards(meetingRoomPages, alcovePages, venuePages),
                    message:          'Room not found'
                };
            }

            return {
                isMeetingRoom:    isMeetingRoom,
                isAlcove:         isAlcove,
                isVenueSpace:     isVenueSpace,
                isWorkstation:    false,
                isAlcovesParent:  false,
                roomName:         currentRoom.name               || '',
                meetingroomDesc:  currentRoom.meetingDescription || '',
                Description:      currentRoom.description        || '',
                thumbnail:        buildImageUrl(currentRoom.thumbnail),
                pageBanner:       buildImageUrl(currentRoom.pageBanner),
                roomImage:        buildImageUrl(currentRoom.roomImage),
                roomCapacity:     currentRoom.roomCapacity        || '',
                roomCards:        buildRoomCards(meetingRoomPages, alcovePages, venuePages),
                message:          response.message                || ''
            };
        }
    });
});
